var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGallery = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#EAEAEA",
  opacity: 0.45,
  cx: 20,
  cy: 20,
  r: 20
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.833 9.833)",
  stroke: "#6D6D78",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.841 18.333H.873A.873.873 0 0 1 0 17.46V3.492c0-.482.39-.873.873-.873h13.968c.482 0 .873.39.873.873V17.46c0 .482-.39.873-.873.873z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.619 2.619V.873c0-.482.39-.873.873-.873H17.46c.482 0 .873.39.873.873v13.968c0 .482-.39.873-.873.873h-1.746"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.714 9.603c-3.928-.8-7.53 6.984-10.214 6.984"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 12.222s2.914-2.4 8.25 2.62"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.802,
  cy: 6.984,
  r: 1.746
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGallery);
export default ForwardRef;